export default {
    props: {
        isDisabled: { type: Boolean, default: false },
    },
}
